<template>
  <span
    v-if="auction.auctionStatus == 'PUBLISHED'"
    class="inline-block bg-yellow-500 p-2 mb-2 text-white uppercase text-xs font-bold"
  >
    <BellIcon class="h-4 w-4 mr-1 inline-block" /> Asta pubblicata
  </span>
  <span
    v-else-if="auction.auctionStatus == 'OPEN'"
    class="inline-block bg-green-700 p-2 mb-2 text-white uppercase text-xs font-bold"
  >
    <BellAlertIcon class="h-4 w-4 mr-1 inline-block" /> Asta in corso
  </span>
  <span
    v-else-if="auction.auctionStatus == 'REDISTRIBUTING_1'"
    class="inline-block bg-orange-500 p-2 mb-2 text-white uppercase text-xs font-bold"
  >
    <BellSnoozeIcon class="h-4 w-4 mr-1 inline-block" /> Redistribuzione - fase 1
  </span>
  <span
    v-else-if="auction.auctionStatus == 'REDISTRIBUTING_2'"
    class="inline-block bg-orange-500 p-2 mb-2 text-white uppercase text-xs font-bold"
  >
    <BellSnoozeIcon class="h-4 w-4 mr-1 inline-block" /> Redistribuzione - fase 2
  </span>
  <span
    v-else-if="auction.auctionStatus == 'CLOSED'"
    class="inline-block bg-stone-500 p-2 mb-2 text-white uppercase text-xs font-bold"
  >
    <BellSlashIcon class="h-4 w-4 mr-1 inline-block" /> Asta chiusa
  </span>
</template>
  
<script setup>
import { BellAlertIcon, BellIcon, BellSlashIcon, BellSnoozeIcon } from '@heroicons/vue/24/solid';
const props = defineProps({
    auction: {
    type: Object,
    required: true
    }
})
</script>